import React from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";

function Revolutionindustries(props) {
  return (
    <section className="tekgrip_section tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={10} lg={10} xl={10} xxl={10}>
            <div className="example" data-text="Training Academics">
              <h2>
                Enhancing Efficiency: Key Features Offered by Our Educational
                Software Development Company
              </h2>
            </div>
            <p className="main_para">
              As a credible educational software company, we strive to build
              feature-rich learning management systems with intuitive design and
              gamified elements to deliver an enhanced online learning
              experience like never before.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Tab.Container defaultActiveKey="0">
              <Row>
                <Col xs={12} md={6} lg={6} xl={6}>
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="0">Serverless Hosting</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="1">Personalized Experience</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="2">Fail-Proof Security</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="3">Offline Access</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="4">Reporting & Assessment</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                  <Tab.Content>
                    <Tab.Pane eventKey="0">
                      <p>
                        We build LMS with cloud integration, eliminating the
                        need for businesses to create dedicated on-premise
                        hosting servers. With our serverless hosting,
                        enterprises, and academic institutions can access their
                        LMS online and scale as per their needs.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="1">
                      <p>
                        Users can customize their dashboards, screens, layouts,
                        and other elements of their learning management system
                        for a seamless, personalized experience.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="2">
                      <p>
                        Our educational software development services provide
                        fail-proof security and privacy features to safeguard
                        our client's confidential data. Moreover, our proactive
                        approach to maintenance prevents any failures or
                        shutdowns to deliver a superior experience.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="3">
                      <p>
                        Users can access their LMS dashboard offline and watch
                        downloaded videos and courses in case of power breakdown
                        or connectivity issues. The offline mode of this
                        educational software ensures that users don't get any
                        resistance to learning and development no matter what!
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="4">
                      <p>
                        Our learning management system allows academic
                        institutions and corporations to conduct online exams
                        and quizzes for evaluation. Academic institutions can
                        cater to their international students, while
                        corporations can use these features to train and
                        evaluate their remote employees.
                      </p>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Revolutionindustries;
